import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sgzp-master.constants';

@Component({
  selector: 'app-sgzp-master-change-password-sent',
  templateUrl: './sgzp-master-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sgzp-master-change-password-sent.component.css',
  ],
})
export class SgzpMasterChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void { }
}
